import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ResourceService } from '@teem/generic/resource.service';
import { services as StoreServicesApi , store as StoreApi } from '@teem/constants/api';
import { StoreService, StoreServiceSerializer } from '@teem/models/store-service';
import { objectToFormData } from '@teem/helpers/functions';

@Injectable({
  providedIn: 'root'
})
export class StoreServiceService extends ResourceService<StoreService> {

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      StoreServicesApi.endPoint,
      new StoreServiceSerializer()
    )
  }

  public action(params: any) {
    return this.httpClient.patch(`${StoreServicesApi.action}`, params);
  }

  public commonData() {
    return this.httpClient.get(`${StoreServicesApi.common}`, this.httpOptions);
  }

  public categories() {
    return this.httpClient.get(`${StoreServicesApi.stats}`, this.httpOptions);
  }

  public setStoreAsBranches(params:any) {
    return this.httpClient.post(`${StoreApi.setBranch}`, params);
  }

  public importFile(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      return this.httpClient.post(`${StoreServicesApi.importFile}`, fd)
    } else {
      return this.httpClient.put(`${StoreServicesApi.importFile}`, params)
    }
  }

}
